<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="0"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container
      :Type="false"
      :ImgUrl="'A0104.png'"
      :ImgUrls="'A0104.png'"
      :Container="Container"
      style="z-index: -6"
    ></Container>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Container from "@/components/Container4.vue";
export default {
  name: "A01",
  data() {
    return {
      Bignav: false,
      Container: {
        title: "經營管理合作與諮詢顧問服務",
        videobtnname: "關於瓦里安 ",
        videosrc: "",
        text:
          "為協助醫院解決開設放射腫瘤科所面對各項難題，瓦里安開展了經營管理合作與諮詢顧問服務。自2002年以來，陸續與全台多家醫院中心及院所建立合作關係，協助籌設科室，引進最新技術並籌組醫療團隊。此外，更積極舉辦各類醫學研討會，為合作醫院創造更高附加價值，達到共贏。",
        listtitle: "服務內容：",
        list: [
          {
            title: "",
            body: "評估最佳化發展策略，協助醫院規劃特色醫療服務"
          },
          {
            title: "",
            body: "引進最新放療技術與設備，提升放療服務的競爭優勢"
          },
          {
            title: "",
            body: "提供財務規劃服務，建立健全的經營體質"
          },
          {
            title: "",
            body: "協助建立醫療服務團隊，規劃臨床醫療流程管理制度"
          },
          {
            title: "",
            body: "專屬交流平台，緊密連結所有合作團隊，分享醫療技術與臨床經驗"
          },
          {
            title: "",
            body: "支持學術研究，運用最新發展技術，開拓學術研究新領域"
          },
          {
            title: "",
            body: "臨床專家諮詢，提升醫療服務品質"
          },
          {
            title: "",
            body: "提供最新功能試用，掌握未來放療發展趨勢"
          }
        ]
      }
    };
  },
  components: {
    Back,
    Container,
    Bigmenu
  },
  methods: {
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
